import React from 'react';

import {ICountryLanguageTriggerItemProps} from './ICountryLanguageTriggerItem';

const CountryLanguageTriggerItem = ({children, className}: ICountryLanguageTriggerItemProps) => {
	return <span className={className}>{children}</span>;
};

export default CountryLanguageTriggerItem;

